import * as React from "react";

import "./list-view.scss";

import {cs}                 from "@Common/react/chain-services";
import {consumeContext}     from "@Common/react/context";
import {Load2}              from "@Common/react/load2";
import {mailingListTypes}   from "@Common/ui-components/heavy/mailing-ui/create-mailing-list-modal/types/mailing-list-types";
import {
    getAddressListTypes,
    filterAddressListTypes
}                           from "@Common/ui-components/heavy/mailing-ui/mailing-icons/address-list-types";
import {TypesGrid}          from "@Common/ui-components/heavy/mailing-ui/types-grid/types-grid";
import {Responsive}         from "@Common/ui-components/responsive";
import {COMPANY_LEVEL}      from "@Xpresso/routes/common/logic/user-level";

import {MlTable}            from "../../../../../common/mailing-lists-panel/ml-table/ml-table";
import {MlColumn}           from "../../../../../common/mailing-lists-panel/ml-column/ml-column";

export const ListView = ({next}) => cs(
     // @ts-ignore
     ["responsive", ({}, next) => <Responsive {...{
        sizes: {
            md: 1024,
        },
        next,
    }}/>],
    consumeContext("apis"),
    ["mailingLists", ({apis}, next) => Load2({
        fetch: () => apis.next.mailing.getMailingLists(),
        next,
    })],
    ({mailingLists, responsive}) => next({
        reload: mailingLists.reload,
        render: ({onCreate}) => cs(
            () => (
                <div className="list-view list-view-1by">

                    <div className="header">
                        <div className="title">
                            Create or Upload a New List
                        </div>
                        <div className="sub-title">
                            Add a new address list by selecting from our robust audience targeting options or uploading your own list.
                        </div>
                    </div>

                    {cs(
                        consumeContext("company"),
                        ["isTypeAllowed", ({company}, next) => cs(
                            consumeContext("session"),
                            consumeContext("userLevels"),
                            ({session, userLevels}) => {
                                const addressListTypes = userLevels?.userLevel === COMPANY_LEVEL ? (
                                    company?.prefs?.addressListTypes
                                ) : (
                                    session.data?.branch?.addressListTypes
                                );

                                return next((t) => addressListTypes?.includes(t));
                            },
                        )],
                        ({company, isTypeAllowed}) => TypesGrid({
                            types: getAddressListTypes(company?.prefs?.enableMapBasedMailingSupport).filter(filterAddressListTypes(isTypeAllowed)),
                            onSelect: (type) => onCreate(mailingListTypes.find((t) => t.value === type).service),
                        }),
                    )}
                    {
                        responsive.lt("md") ? (
                            MlColumn({mailingLists})
                        ) : (
                            MlTable({mailingLists})
                        )
                    }                  
                </div>
            ),
        ),
    })
);
